import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dispatch-group-header',
  templateUrl: './dispatch-group-header.component.html',
  styleUrls: ['./dispatch-group-header.component.scss']
})
export class DispatchGroupHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
